import { render, staticRenderFns } from "./PaymentProviderChoice.vue?vue&type=template&id=648dad48"
import script from "./PaymentProviderChoice.vue?vue&type=script&lang=js"
export * from "./PaymentProviderChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports